export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: any; output: any };
};

export type AccommodationType = {
  __typename?: "AccommodationType";
  code: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  isArchived: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  translations: Array<AccommodationTypeTranslation>;
};

export type AccommodationTypeTranslation = {
  __typename?: "AccommodationTypeTranslation";
  language: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type Amenity = {
  __typename?: "Amenity";
  description: Scalars["String"]["output"];
  translations: Array<AmenityTranslation>;
  value: Scalars["Int"]["output"];
};

export type AmenityTranslation = {
  __typename?: "AmenityTranslation";
  description?: Maybe<Scalars["String"]["output"]>;
  language: Scalars["String"]["output"];
};

export type AvailableRateGroupsInput = {
  checkIn: Scalars["Date"]["input"];
  checkOut: Scalars["Date"]["input"];
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CalculateCartInput = {
  accommodations: Array<CartAccommodationInput>;
};

export type CalculateCartPayload = {
  __typename?: "CalculateCartPayload";
  cart: Cart;
};

export enum CalculationRule {
  PerDay = "PER_DAY",
  PerPerson = "PER_PERSON",
  PerPersonPerDay = "PER_PERSON_PER_DAY",
  PerUnit = "PER_UNIT",
}

export type CancelationPolicy = {
  __typename?: "CancelationPolicy";
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  translations: Array<CancelationPolicyTranslation>;
};

export type CancelationPolicyTranslation = {
  __typename?: "CancelationPolicyTranslation";
  description: Scalars["String"]["output"];
  language: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type CarrierInfoInput = {
  address: Scalars["String"]["input"];
  city: Scalars["String"]["input"];
  companyInfo?: InputMaybe<CompanyInfoInput>;
  countryIso: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  phoneNumber: Scalars["String"]["input"];
  postalCode: Scalars["String"]["input"];
};

export type Cart = {
  __typename?: "Cart";
  accommodations: Array<CartAccommodation>;
  downPaymentAmount: Scalars["Float"]["output"];
  isForcedInquiry: Scalars["Boolean"]["output"];
  priceBreakdown: Price;
  /** @deprecated Use field priceBreakdown instead */
  total: Scalars["Float"]["output"];
};

export type CartAccommodation = {
  __typename?: "CartAccommodation";
  extras: Array<CartAccommodationExtra>;
  /** Optional identifier for calculation */
  identifier?: Maybe<Scalars["ID"]["output"]>;
  priceBreakdown: Price;
  rateBasePrice: Scalars["Float"]["output"];
  ratePlan: RatePlan;
  /** @deprecated Use field priceBreakdown instead */
  total: Scalars["Float"]["output"];
};

export type CartAccommodationExtra = {
  __typename?: "CartAccommodationExtra";
  calculatedQuantity: Scalars["Int"]["output"];
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  quantity: Scalars["Int"]["output"];
  total: Scalars["Float"]["output"];
  translations: Array<ExtraTranslation>;
};

export type CartAccommodationExtraInput = {
  extraId: Scalars["ID"]["input"];
  quantity: Scalars["Int"]["input"];
};

export type CartAccommodationInput = {
  checkIn: Scalars["Date"]["input"];
  checkOut: Scalars["Date"]["input"];
  extras: Array<CartAccommodationExtraInput>;
  /** Optional identifier for calculation */
  identifier?: InputMaybe<Scalars["ID"]["input"]>;
  parcelObjects?: InputMaybe<ParcelObjectsInput>;
  persons: Array<PersonInput>;
  ratePlanId: Scalars["ID"]["input"];
};

export type CompanyInfoInput = {
  address: Scalars["String"]["input"];
  countryIso: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  vatId: Scalars["String"]["input"];
};

export type CompatibleExtrasInput = {
  checkIn: Scalars["Date"]["input"];
  checkOut: Scalars["Date"]["input"];
  persons: Array<PersonInput>;
  ratePlanId: Scalars["ID"]["input"];
};

export type Country = {
  __typename?: "Country";
  iso3Code: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type Extra = {
  calculationRule: CalculationRule;
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inputType: InputType;
  name: Scalars["String"]["output"];
  price: Scalars["Float"]["output"];
  translations: Array<ExtraTranslation>;
};

export type ExtraTranslation = {
  __typename?: "ExtraTranslation";
  description?: Maybe<Scalars["String"]["output"]>;
  language: Scalars["String"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

export type Image = {
  __typename?: "Image";
  galleryPositionIndex?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  isPrimary: Scalars["Boolean"]["output"];
  url: Scalars["String"]["output"];
};

export enum InputType {
  Checkbox = "CHECKBOX",
  NumberSelect = "NUMBER_SELECT",
}

export type LoadReservationOfferInput = {
  reservationOfferId: Scalars["ID"]["input"];
};

export type LoadReservationOfferPayload = {
  __typename?: "LoadReservationOfferPayload";
  reservationOffer: ReservationOffer;
};

export type MandatoryExtra = Extra & {
  __typename?: "MandatoryExtra";
  calculationRule: CalculationRule;
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inputType: InputType;
  /** Calculated quantity for provided booking data */
  mandatoryQuantity: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  price: Scalars["Float"]["output"];
  translations: Array<ExtraTranslation>;
};

export enum MealType {
  AllInclusive = "ALL_INCLUSIVE",
  American = "AMERICAN",
  BedAndBreakfast = "BED_AND_BREAKFAST",
  Bermuda = "BERMUDA",
  Breakfast = "BREAKFAST",
  BreakfastAndLunch = "BREAKFAST_AND_LUNCH",
  BuffetBreakfast = "BUFFET_BREAKFAST",
  CaribbeanBreakfast = "CARIBBEAN_BREAKFAST",
  ContinentalBreakfast = "CONTINENTAL_BREAKFAST",
  Dinner = "DINNER",
  DinnerBedAndBreakfastPlan = "DINNER_BED_AND_BREAKFAST_PLAN",
  EnglishBreakfast = "ENGLISH_BREAKFAST",
  EuropeanPlan = "EUROPEAN_PLAN",
  FamilyAmerican = "FAMILY_AMERICAN",
  FamilyPlan = "FAMILY_PLAN",
  FullBoard = "FULL_BOARD",
  FullBreakfast = "FULL_BREAKFAST",
  HalfBoard = "HALF_BOARD",
  Lunch = "LUNCH",
  LunchAndDinner = "LUNCH_AND_DINNER",
  None = "NONE",
  RoomOnly = "ROOM_ONLY",
  SelfCatering = "SELF_CATERING",
}

export type Mutation = {
  __typename?: "Mutation";
  calculateCart?: Maybe<CalculateCartPayload>;
  loadReservationOffer?: Maybe<LoadReservationOfferPayload>;
  submitCart?: Maybe<SubmitCartPayload>;
};

export type MutationCalculateCartArgs = {
  input: CalculateCartInput;
};

export type MutationLoadReservationOfferArgs = {
  input: LoadReservationOfferInput;
};

export type MutationSubmitCartArgs = {
  input: SubmitCartInput;
};

export type OptionalExtra = Extra & {
  __typename?: "OptionalExtra";
  calculationRule: CalculationRule;
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inputType: InputType;
  name: Scalars["String"]["output"];
  price: Scalars["Float"]["output"];
  translations: Array<ExtraTranslation>;
};

export type Organization = {
  __typename?: "Organization";
  logoUrl?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  paymentType: PaymentProviderEnum;
  privacyPolicy: Scalars["String"]["output"];
  termsAndConditions: Scalars["String"]["output"];
  translations: Array<OrganizationTranslation>;
};

export type OrganizationTranslation = {
  __typename?: "OrganizationTranslation";
  language: Scalars["String"]["output"];
  privacyPolicy?: Maybe<Scalars["String"]["output"]>;
  termsAndConditions?: Maybe<Scalars["String"]["output"]>;
};

export enum ParcelObjectType {
  Camper = "CAMPER",
  Caravan = "CARAVAN",
  Tent = "TENT",
}

export type ParcelObjectsInput = {
  dimensions: Scalars["String"]["input"];
  tentDimensions: Scalars["String"]["input"];
  type: ParcelObjectType;
};

export type PaymentDetailsInput = {
  encryptedCardDetails: Scalars["String"]["input"];
  holderFirstName: Scalars["String"]["input"];
  holderLastName: Scalars["String"]["input"];
};

export enum PaymentProviderEnum {
  NoPayment = "NO_PAYMENT",
  WsPay = "WS_PAY",
  WsPayPer = "WS_PAY_PER",
}

export type PaymentStatus = {
  __typename?: "PaymentStatus";
  paymentStatus: PaymentStatusEnum;
  redirectUrl?: Maybe<Scalars["String"]["output"]>;
};

export enum PaymentStatusEnum {
  NoPaymentRequired = "NO_PAYMENT_REQUIRED",
  Paid = "PAID",
  PaymentRedirect = "PAYMENT_REDIRECT",
}

export type PersonInput = {
  age?: InputMaybe<Scalars["Int"]["input"]>;
  type: PersonType;
};

export enum PersonType {
  Adult = "ADULT",
  Child = "CHILD",
}

export type Price = {
  __typename?: "Price";
  discountPercentage: Scalars["Float"]["output"];
  withDiscount: Scalars["Float"]["output"];
  withoutDiscount: Scalars["Float"]["output"];
};

export type Query = {
  __typename?: "Query";
  accommodationTypes: Array<AccommodationType>;
  availableRateGroups: Array<RateGroup>;
  compatibleExtras: Array<Extra>;
  countries: Array<Country>;
  currentOrganization?: Maybe<Organization>;
};

export type QueryAvailableRateGroupsArgs = {
  filter?: InputMaybe<Array<RateGroupFilter>>;
  input?: InputMaybe<AvailableRateGroupsInput>;
};

export type QueryCompatibleExtrasArgs = {
  input: CompatibleExtrasInput;
};

export type RateGroup = {
  __typename?: "RateGroup";
  accommodationType?: Maybe<AccommodationType>;
  amenities: Array<Amenity>;
  code: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  guestAdditionalCapacity: Scalars["Int"]["output"];
  guestCapacity: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  images: Array<Image>;
  isArchived: Scalars["Boolean"]["output"];
  isParcel: Scalars["Boolean"]["output"];
  maxAvailability: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  ratePlans: Array<RatePlan>;
  translations: Array<RateGroupTranslation>;
};

export type RateGroupMaxAvailabilityArgs = {
  from: Scalars["Date"]["input"];
  until: Scalars["Date"]["input"];
};

export type RateGroupFilter = {
  accommodationType__code?: InputMaybe<StringFilter>;
  accommodationType__id?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  isParcel?: InputMaybe<BoolFilter>;
};

export type RateGroupTranslation = {
  __typename?: "RateGroupTranslation";
  description?: Maybe<Scalars["String"]["output"]>;
  language: Scalars["String"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

export type RatePlan = {
  __typename?: "RatePlan";
  cancelationPolicy?: Maybe<CancelationPolicy>;
  /** Total price breakdown for 2 adults */
  defaultPriceBreakdown: Price;
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  isArchived: Scalars["Boolean"]["output"];
  isAvailable: Scalars["Boolean"]["output"];
  /** Lowest price for 2 adults */
  lowestPrice: Scalars["Float"]["output"];
  mealType: MealType;
  name: Scalars["String"]["output"];
  occupancy: Scalars["Int"]["output"];
  parentPerPersonRatePlan?: Maybe<RatePlan>;
  rateSellMode: RateSellMode;
  translations: Array<RatePlanTranslation>;
};

export type RatePlanDefaultPriceBreakdownArgs = {
  from: Scalars["Date"]["input"];
  until: Scalars["Date"]["input"];
};

export type RatePlanIsAvailableArgs = {
  from: Scalars["Date"]["input"];
  until: Scalars["Date"]["input"];
};

export type RatePlanLowestPriceArgs = {
  from: Scalars["Date"]["input"];
  until: Scalars["Date"]["input"];
};

export type RatePlanTranslation = {
  __typename?: "RatePlanTranslation";
  description?: Maybe<Scalars["String"]["output"]>;
  language: Scalars["String"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

export enum RateSellMode {
  PerPerson = "PER_PERSON",
  PerRoom = "PER_ROOM",
}

export type Reservation = {
  __typename?: "Reservation";
  id: Scalars["ID"]["output"];
};

export type ReservationOffer = {
  __typename?: "ReservationOffer";
  accommodations: Array<ReservationOfferAccommodation>;
  id: Scalars["ID"]["output"];
};

export type ReservationOfferAccommodation = {
  __typename?: "ReservationOfferAccommodation";
  checkIn: Scalars["Date"]["output"];
  checkOut: Scalars["Date"]["output"];
  guests: Array<ReservationOfferGuest>;
  id: Scalars["ID"]["output"];
  ratePlan: RatePlan;
};

export type ReservationOfferGuest = {
  __typename?: "ReservationOfferGuest";
  age?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  personType: PersonType;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars["String"]["input"]>;
  equals?: InputMaybe<Scalars["String"]["input"]>;
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
  notEquals?: InputMaybe<Scalars["String"]["input"]>;
};

export type SubmitCartInput = {
  accommodations: Array<CartAccommodationInput>;
  carrier: CarrierInfoInput;
  isInquiry?: InputMaybe<Scalars["Boolean"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  payment?: InputMaybe<PaymentDetailsInput>;
  /** Total amount previously calculated, used to detect price changes between initial calculation and submit */
  totalAmount: Scalars["Float"]["input"];
};

export type SubmitCartPayload = {
  __typename?: "SubmitCartPayload";
  paymentStatus: PaymentStatus;
  reservation: Reservation;
};
